// extracted by mini-css-extract-plugin
module.exports = {"navIcon":"kCqKZ","rc-tabs-bar":"OYCKi","rc-tabs-tab":"_7m8pB","rc-tabs-tab-active":"R8Q-W","terms":"tbtkS","orderHistory-navigation":"_6QGPf"};